import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <b>
              {" "}
              <p>Study Area</p>
            </b>

            <p>
              Karnataka is the eighth largest state in India with varied agro
              climatic zones (Figure 1) and population density of 319 persons
              per sq.km as per 2011 census. It lies between 11.5&deg; and
              18.50&deg; N and 74&deg; and 78.30&deg; E in the southern plateau
              with a geographic area of 1,91,791 km<sup>2</sup>. It is bordered
              by Arabian Sea to the west, Goa to the northwest, Maharashtra to
              the north, Andhra Pradesh to the east, Tamil Nadu to the east and
              southeast, and Kerala to the southwest. The state comprises of
              diverse topographical features of high mountains, plateaus,
              residual hills and coastal plains and is enclosed by chains of
              mountains to its west, east and south. The region is endowed with
              the most magnificent forests in the country, from the rich
              evergreen forests of the Western Ghats to the scrub jungles of the
              plains, a wide variety of habitats exist and some of them endemic
              to the region. The weather is very dynamic, changes from place to
              place owing to its altitude, topography and its distance from the
              sea. It experiences climatic variations from arid to semi-arid in
              the plateau region, sub-humid to humid tropical in the Western
              Ghats and humid tropical monsoon in the coastal plains. The mean
              rainfall varies from 400 mm in the Eastern parts to more than 4000
              mm in the Western Ghats and coastal beach of the State.
            </p>
            <p>&nbsp;</p>
            <p>
              {" "}
              <b> Method</b>
            </p>
            <p>
              The method adopted for the analysis is illustrated in Figure 2. LU
              analysis involved (i) generation of False Color Composite (FCC) of
              remote sensing data (bands&ndash;green, red and NIR). This
              composite image helps in locating heterogeneous patches in the
              landscape, (ii) selection of training polygons by covering 15% of
              the study area (polygons are uniformly distributed over the entire
              study area) (iii) 60% of the training data has been used for
              classification, while the balance is used for validation or
              accuracy assessment. (iv) LU analysis was done using supervised
              classification technique based on Gaussian maximum likelihood
              algorithm through GRASS GIS (Geographical Resources Analysis
              Support System) a free and open source software accessible at
              http.//wgbis.ces.iisc.ac.in/grass/index.php. MODIS Land surface
              temperature (LST) and emissivity data has retrieved from Land
              Processes Distributed Active Archive Center (LPDAAC), which has
              been re-projected from sinusoidal projection to UTM Zone 43
              projection with WGS 84 datum using MODIS Re-Projection Tools. To
              investigate temporal patterns of temperature across the study
              region 2005, 2012 and 2018 of May month data were used. LST was
              computed by multiplying DN (Digital numbers) with a scale factor
              of 0.02 and then converted into degree Celsius. Validation of land
              surface temperature was done using ground data of 0.5 degree
              downloaded from Princeton University which gives air temperature
              above 2m ground level. Finally, statistical analysis has performed
              to understand the relationship among various LU classes and LST.
            </p>
            <p style={{textAlign:"center"}}> <img src="images/ldk1.png" alt="" /> </p>
            <p style={{textAlign:"center"}}>Figure1. Geographic location of the study area.</p>
                        <p style={{textAlign:"center"}}> <img src="images/ldk2.png" alt="" /> </p>

            <p style={{textAlign:"center"}}>Figure 2. Method adopted</p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
